import {
  ACTION_EDIT_POSTBACK_SETTINGS__REQUEST,
  ACTION_EDIT_POSTBACK_SETTINGS__SUCCESS,
  ACTION_EDIT_POSTBACK_SETTINGS__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_EDIT_POSTBACK_SETTINGS__REQUEST:
    case ACTION_EDIT_POSTBACK_SETTINGS__SUCCESS:
      return null;

    case ACTION_EDIT_POSTBACK_SETTINGS__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
